// Auto-generated: imports for all layout scripts
// This file is maintained by scripts/build-assets.js
// Do not edit manually - changes will be overwritten

import '../../flex/content/layouts/contact_cta/contact_cta.js';
import '../../flex/content/layouts/content_afbeelding/content_afbeelding.js';
import '../../flex/content/layouts/content_afbeelding_grid/content_afbeelding_grid.js';
import '../../flex/content/layouts/content_slider/content_slider.js';
import '../../flex/content/layouts/content_stacking_images_faq/content_stacking_images_faq.js';
import '../../flex/content/layouts/faq_archive/faq_archive.js';
import '../../flex/content/layouts/faq_overview/faq_overview.js';
import '../../flex/content/layouts/hero_bedankt/hero_bedankt.js';
import '../../flex/content/layouts/hero_solliciteren/hero_solliciteren.js';
import '../../flex/content/layouts/hero_vacature_detail/hero_vacature_detail.js';
import '../../flex/content/layouts/hero_video/hero_video.js';
import '../../flex/content/layouts/home_overview/home_overview.js';
import '../../flex/content/layouts/opleidingen_overview/opleidingen_overview.js';
import '../../flex/content/layouts/text_intro/text_intro.js';
import '../../flex/content/layouts/vacature_detail_intro/vacature_detail_intro.js';
import '../../flex/content/layouts/vacature_overview/vacature_overview.js';
import '../../flex/content/layouts/verhaal_gallery/verhaal_gallery.js';
import '../../flex/content/layouts/verhaal_quote/verhaal_quote.js';
import '../../flex/content/layouts/verhaal_slider/verhaal_slider.js';
